/**
*
* Button
*
*/

/*
 * TODO:
 * import(are) { Link } from 'gatsby' (non ancora presente in /shared);
 * Sostiuire poi styled.a con styled(Link)
 */

import styled, { css } from 'styled-components';
import { colore } from '../../style/color';
import media from '../../style/mediainjector';

export const ButtonStyle = css`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ flexDirection }) => flexDirection};
  text-align: center;
  color: ${(props) => (props.color ? props.color : colore.ui.contrast)};
  margin: ${(props) => props.margin};
  padding: ${(props) => (props.padding ? props.padding : '0.6rem  1.2em')};
  border: ${(props) => (props.border ? props.border : 'none')};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.brand)};
  border-radius: ${(props) => (props.radius ? props.radius : (props.theme.radius || {}).buttons)};
  ${({ full }) => full && 'width: 100% !important;'};
  text-decoration: ${({ textDecoration }) => textDecoration};
  &:disabled {
    box-shadow: none;
    background: rgba(222,222,222,0.6);
    pointer-events: none;
  }
`;

export const Button = styled.button`
  ${ButtonStyle}
`;

export const ActionButtonStyle = css`
  color: ${(props) => (props.color ? props.color : colore.ui.contrast)};
  min-width:180px;
  font-weight: 600;
  padding: ${(props) => (props.padding ? props.padding : '21px 30px')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '2.1rem')};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.brand)};
  border-radius: ${(props) => (props.radius ? props.radius : (props.theme.radius || {}).buttons)};
  ${({ shadow }) => shadow && css`
    border: none;
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.20);
  `}
  ${({ shadowPlus }) => shadowPlus && css`
    border: none;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    ${media.gt768`
      &:hover {
      box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
      }
    `}
  `}
  ${({ bone }) => bone && css`
    color: #fff;
    border: 2px solid #fff;
    background-color: ${(props) => (props.bgcolor ? props.bgcolor : 'rgba(255, 255, 255, 0)')};
    &:hover,
    &:active {
      background-color: rgba(0,0,0,.1);
    }
  `}
  ${media.lt768`
    font-size: 18px;
  `}
  ${({ sectionbutton }) => sectionbutton && css`
    min-width: 50%;
    font-size: 18px;
    padding: 14px 30px;
    ${media.lt667`
      width: 100%;
    `}
  ${media.lt480`
    font-size: 16px;
    `}
  `}
`;

export const ActionButton = styled(Button)`
  ${ActionButtonStyle};
  ${({ goFull }) => goFull && css`
    ${media.lt667`
      min-width: 100%;
      width: 100%;
    `}
  `}
`;

export const ButtonA = styled.a`
  ${ButtonStyle}
  text-decoration: none;
`;

export const ActionButtonA = styled(ButtonA)`
  ${ActionButtonStyle};
`;
